module.exports = __webpack_public_path__ + "img/img25.66b16f0d.png";